<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Broker Group',
    path: '/broker-group',
    active: true
}]"></app-breadcrumb>
<app-page-header title="Broker Groups" [buttons]="[{
        name: 'Add',
        eventName: 'add',
        cssClass: 'bg-primary'
    }]" (onButtonClick)="action($event)">
</app-page-header>
<app-page-content>
    <app-data-grid [dataSource]="dataSource" [config]="config" [dataLength]="dataSource.length" [isLoading]="isLoading"
        (dataActionEvent)="action($event)">
    </app-data-grid>
</app-page-content>

<app-slide-panel title="{{ this.editSelected ? 'Edit' : 'Add' }}" [(visible)]="panelVisible" *ngIf="panelVisible">
    <app-broker-group-add-edit [group]="editSelected" (onDone)="onPopupclose()">
    </app-broker-group-add-edit>
</app-slide-panel>